// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InfraImpactSchema = z.enum(['DOMAIN_COMPROMISE','HOST_COMPROMISE','DOMAIN_USER_COMPROMISE','SENSITIVE_DATA_EXPOSURE','RANSOMWARE_EXPOSURE','CREDENTIAL_EXPOSURE','PRIVILEGE_ESCALATION','LATERAL_MOVEMENT'] as const);

export type InfraImpactType = `${z.infer<typeof InfraImpactSchema>}`

export default InfraImpactSchema;
